<template>
  <div v-loading="loading" style="">
    <el-card shadow="never" style="padding-bottom: 10px">
      <el-col :xs="12" :sm="12" :md="12" :lg="5" style="padding-top: 2pt">
        <span class="head-title">List of Overdue Deductions ( {{ aStatusLabel }} )</span>
      </el-col>
    </el-card>
    <el-row>
      <el-col :lg="24">
        <el-card class="box-card" >
          <el-table
            ref="multipleTable"
            :data="empDeduction"
            :cell-class-name="setclass"
            :header-cell-class-name="setheadclass"
            height="400"
            size="small"
            style="width: 100%">
            <el-table-column
              fixed
              width="50">
              <template slot-scope="scope">
                <el-checkbox :key="scope.row.id" :checked="scope.row.active===1" @change="changeStatus(scope.row.id, $event)" />
              </template>
            </el-table-column>
            <el-table-column prop="fullname" label="Fullname" width="150"/>
            <el-table-column prop="ref_deduction.code" label="Code" width="150"/>
            <el-table-column prop="ref_deduction.desc" label="Deduction" width="350"/>
            <el-table-column label="Start Date" >
              <template slot-scope="scope">
                {{ format_date(scope.row.deduction_details.startdate) }}
              </template>
            </el-table-column>
            <el-table-column label="End Date" >
              <template slot-scope="scope">
                {{ format_date(scope.row.deduction_details.enddate) }}
              </template>
            </el-table-column>
            <el-table-column prop="deduction_details.amount" label="Amount" >
              <template slot-scope="scope">
                {{ Number(scope.row.deduction_details.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <!--            <el-table-column label="update" >-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-button type="warning" size="small" @click="update(scope.row)" ><i class="el-icon-edit"/></el-button>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EmpDeduction } from '../../../api/payroll/empdeduction'
import moment from 'moment'

export default {
  name: 'Overdue',
  data() {
    return {
      tenure: parseInt(this.$store.getters.APStatus),
      meta: {
        page: 1
      },
      loading: false,
      deduction: {},
      total: 0,
      addDeduction: false,
      empDeduction: [],
      dialogFormVisible: false,
      enddate_option: {
        disabledDate: (date) => {
          if (this.form.startdate !== null) {
            return date.getTime() < this.form.startdate
          }
        }
      },
      aStatusLabel: null,
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id
    }
  },
  created() {
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
    if (this.tenure === 3) { this.aStatusLabel = 'Permanent' }
    if (this.tenure === 2) { this.aStatusLabel = 'Contractual' }
    if (this.tenure === 1) { this.aStatusLabel = 'Casual' }
    this.getAll()
  },
  methods: {
    getAll() {
      this.loading = true
      EmpDeduction({ overdue: true, page: this.meta.page, 'tenure': this.tenure, campus_id: this.campus_id }, 'get', '').then(res => {
        this.empDeduction = res.data.empdeduction
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    changeStatus(id, event) {
      EmpDeduction({ id: id, status: event }, 'post', 'set-active').then(res => {
        if (event) {
          this.$message({ message: 'Activated.', type: 'success' })
        } else {
          this.$message({ message: 'Deactivated.', type: 'warning' })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getFormattedDate(date) {
      if (date) return this.$moment(date).format('YYYY-MM-DD')
      return null
    },
    format_date(value) {
      if (value) return moment(String(value)).format('MM/DD/YYYY')
      return '--'
    },
    setclass(row) {
      if (row.columnIndex === 6) {
        return 'cell_' + row.columnIndex
      }
    },
    setheadclass(row) {
      if (row.columnIndex === 6) {
        return 'header_' + row.columnIndex
      }
    }
  }
}
</script>

<style lang="scss">
  .el-alert--info {
    background-color: #e1ffd0 !important;
  }
  .cell_6 {
    text-align: right;
  }
  .header_6 {
    text-align: center !important;
  }
</style>
